import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight, X } from 'lucide-react';
import { Button } from './ui/button';

const StickyCTAMobile = ({ onCtaClick, show = true }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling 400px
      if (window.scrollY > 400 && !isDismissed) {
        setIsVisible(true);
      } else if (window.scrollY <= 400) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (!show || !isVisible || isDismissed) return null;

  return (
    <div 
      data-testid="sticky-cta-mobile"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-slate-200 shadow-2xl shadow-slate-900/20 p-3 animate-slide-up"
    >
      <div className="flex items-center gap-2">
        <Button
          onClick={onCtaClick}
          className="flex-1 bg-[#0066CC] hover:bg-[#0052A3] text-white h-12 rounded-xl font-semibold text-base shadow-lg"
        >
          {t('sticky_cta.button')}
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
        <button 
          onClick={() => setIsDismissed(true)}
          className="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-600"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      <p className="text-center text-xs text-slate-500 mt-1">
        {t('sticky_cta.subtext')}
      </p>
    </div>
  );
};

export default StickyCTAMobile;
